import React from 'react';
import {
  Edit, SimpleForm, TextInput, TextField, email, required
} from 'react-admin';
import CloseToolbar from './../lib/CloseToolbar';

const validateProfile = values => {
  const errors = {};
  if (values.password || values.password2) {
    if (!values.password) {
      errors.password = 'Bitte ein neues Passwort eingeben.';
    }
    if (values.password !== values.password2) {
      errors.password2 = 'Die beiden Passwörter stimmen nicht überein.';
    }
  }
  return errors;
};

const transform = data => {
  const result = {
    benutzername: data.benutzername,
    vorname: data.vorname,
    name: data.name,
  };
  if (data.password) {
    result.password = data.password;
  }
  return result;
};

const Profile = props => (
  <Edit {...props} title="Mein Profil" undoable={false} transform={transform}>
    <SimpleForm toolbar={<CloseToolbar redir="/" nextstep="/" />} validate={validateProfile}>
      <TextInput source="benutzername" label="E-Mail" validate={[required(), email()]} />
      <TextInput source="vorname" label="Vorname" />
      <TextInput source="name" label="Name" />
      <TextField source="section_name" label="Sektion" />
      <TextField source="usergroup_name" label="Benutzergruppe" />
      {/* inputProps ueberschreiben data-lpignore aus dem theme: lastpass darf hier ein neues passwort generieren/speichern */}
      <TextInput source="password" label="Neues Passwort" type="password" inputProps={{ autoComplete: 'new-password' }} />
      <TextInput source="password2" label="Passwort wiederholen" type="password" inputProps={{ autoComplete: 'new-password' }} />
    </SimpleForm>
  </Edit>
);

export default Profile;
